{
  "breadcrumbAriaLabel": "Tautan Navigasi",
  "homeAriaLabel": "Laman Utama",
  "mainNavAriaLabel": "Navigasi Utama",
  "closeSidebarAriaLabel": "Tutup bar sisi",
  "collapse": "Runtuhkan",
  "help": "Bantuan",
  "settings": "Tetapan",
  "myProfile": "Profil Saya",
  "groups": {
    "clinical": "Klinikal",
    "worklists": "Senarai Kerja",
    "documentation": "Dokumentasi Klinikal",
    "orders": "Pesanan Klinikal",
    "medications": "Ubat-ubatan",
    "scheduling": "Penjadualan",
    "billing": "Pengebilan",
    "analytics": "Analitik",
    "organization": "Organisasi",
    "security": "Keselamatan",
    "accessReviews": "Access Reviews",
    "integrations": "Integrasi",
    "system": "Sistem",
    "licensing": "Pelesenan"
  },
  "dashboard": "Papan Pemuka",
  "patients": "Pesakit",
  "patientSearch": "Cari Pesakit",
  "myPatients": "Pesakit Saya",
  "censusBedBoard": "Pesakit Dalam / Papan Katil",
  "providerDirectory": "Direktori Doktor",
  "providerCoverage": "Liputan Bertugas Doktor",
  "patientMerge": "Gabungkan Rekod Pesakit",
  "inbox": "Peti masuk",
  "pendingResults": "Keputusan Menunggu",
  "criticalResults": "Keputusan Kritikal",
  "unsignedNotes": "Nota Belum Ditandatangan",
  "cosignQueue": "Baris Gilir Tandatangan Bersama",
  "noteTemplates": "Templat Nota",
  "smartPhrases": "Frasa Pintar",
  "orderCatalog": "Katalog Pesanan",
  "orderSets": "Set Pesanan",
  "encounters": "Lawatan Klinikal",
  "orders": "Pesanan Klinikal",
  "results": "Keputusan",
  "medications": "Ubat-ubatan",
  "notes": "Nota Klinikal",
  "medicationWorklist": "Medication Worklist",
  "formulary": "Formulari Ubat",
  "pharmacistQueue": "Baris Gilir Ahli Farmasi",
  "appointments": "Temu Janji",
  "scheduleManagement": "Pengurusan Jadual",
  "waitlist": "Senarai Menunggu",
  "charges": "Caj",
  "claims": "Tuntutan",
  "payments": "Pembayaran",
  "accounts": "Akaun",
  "statements": "Penyata",
  "denials": "Penolakan Tuntutan",
  "analyticsDashboard": "Papan Pemuka",
  "reports": "Laporan",
  "qualityMeasures": "Petunjuk Kualiti",
  "healthSystems": "Sistem Kesihatan",
  "facilities": "Kemudahan",
  "locations": "Lokasi",
  "clinicalTaxonomy": "Taksonomi Klinikal",
  "serviceLocation": "Perkhidmatan ↔ Lokasi",
  "providers": "Kakitangan Perubatan",
  "users": "Pengguna",
  "roles": "Peranan",
  "accessMatrix": "Matriks Akses",
  "integrations": "Integrasi",
  "thirdPartyApps": "Aplikasi Pihak Ketiga",
  "audit": "Audit",
  "system": "Sistem",
  "cdsRules": "Peraturan CDS",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "Cari",
    "register": "Daftar",
    "demographics": "Demografi",
    "census": "Pesakit Dalam",
    "discharge": "Discaj",
    "catalog": "Katalog",
    "sets": "Set Pesanan",
    "pending": "Menunggu",
    "critical": "Kritikal",
    "reconciliation": "Penyelarasan Ubat",
    "worklist": "Senarai Kerja",
    "templates": "Templat",
    "smartPhrases": "Frasa Pintar",
    "schedule": "Pengurusan Jadual",
    "quality": "Petunjuk Kualiti",
    "administration": "Pentadbiran",
    "auditLog": "Log Audit",
    "allergies": "Alahan",
    "problems": "Senarai Masalah",
    "immunizations": "Imunisasi",
    "insurance": "Insurans"
  },
  "handoffs": "Serah Tugas",
  "duplicateReview": "Semakan Pendua",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "Senarai Kerja Pesanan"
}
